import { render } from "./PackageItemList.vue?vue&type=template&id=34a632be&scoped=true"
import script from "./PackageItemList.vue?vue&type=script&lang=js"
export * from "./PackageItemList.vue?vue&type=script&lang=js"

import "./PackageItemList.vue?vue&type=style&index=0&id=34a632be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34a632be"]])

export default __exports__